export enum UserAuthErrorCode {
    /**
     * User Auth service error codes
     */
    INTERNAL_ERROR = 'UA:1000',
    USER_DOES_NOT_EXIST = 'UA:1100',
    OUTSIDE_GEOFENCE = 'UA:1200',
    USER_EXCLUDED_GAMBLING_AUTHORITY = 'UA:1300',
    MITID_SSN_MISMATCH = 'UA:1400',
    INVALID_EMAIL_OR_PASSWORD = 'UA:1500',
    RATE_LIMIT_EXCEEDED = 'UA:1600',
    USER_MUST_REACTIVATE = 'UA:1700',
    REACTIVATION_FAILED_DUE_TO_BEING_SUSPENDED = 'UA:1800',
    TURNSTILE_CANNOT_BE_VERIFIED = 'UA:1900',
    MAGIC_LINK = 'UA:2000',
    REACTIVATION_FAILED_DUE_TO_GAMBLING_EXCLUSION = 'UA:2100',
    PASSWORD_RESET_INVALID_TOKEN = 'UA:3000',
    PASSWORD_RESET_OUTSIDE_GEOFENCE = 'UA:3200',
    PASSWORD_RESET_RATE_LIMITED = 'UA:3300',
}

export const ErrorCode = {
    USER_AUTH: UserAuthErrorCode
}
